import { render, staticRenderFns } from "./FeaturedProductRow.vue?vue&type=template&id=28635023&scoped=true"
import script from "./FeaturedProductRow.vue?vue&type=script&lang=js"
export * from "./FeaturedProductRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28635023",
  null
  
)

export default component.exports